import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import SVG from 'react-inlinesvg';
import { useSelector } from 'react-redux';

import styles from './RobotMarker.module.scss';

import MODELS from '@/models';

const cx = classNames.bind(styles);

const RobotMarker = ({ data: robot, hideDirection = false }) => {
  const robots = useSelector((state) => state.robots);
  const targetRobotIds = useSelector((state) => state.robot?.targetRobotIds);

  const scale = useMemo(() => {
    return targetRobotIds?.includes(robot.id) ? 1.2 : 1;
  }, [targetRobotIds]);

  const color = useMemo(() => {
    return robots.find(({ id }) => id === robot.id)?.color;
  }, [robots]);

  const iconUrl = useMemo(() => {
    return MODELS[robot.model.id].icon;
  }, [robot.model.id]);

  return (
    <div className={cx('container')} style={{ transform: `scale(${scale})` }}>
      <SVG src={iconUrl} width="48" height="48" fill={color} stroke="rgba(255, 255, 255, 0.5)" strokeWidth={8} />
      {!hideDirection && (
        <div className={cx('header')}>
          <div className={cx('line')} />
          <div className={cx('arrow')} />
        </div>
      )}
    </div>
  );
};

export default RobotMarker;
